import {create} from 'zustand';

interface TabSettings {
  canTitleEdit: boolean;
}

interface TabSettingsStore {
  state: {
    [key: string]: TabSettings;
  };
  setCanTitleEdit: (stepId: string, canEdit: boolean) => void;
  getSettingsById: (stepId: string) => TabSettings;
}

export const useTabSettingsStore = create<TabSettingsStore>((set, get) => ({
  state: {},

  setCanTitleEdit: (stepId: string, canEdit: boolean) => {
    set((state) => ({
      state: {
        ...state.state,
        [stepId]: {
          ...state.state[stepId],
          canTitleEdit: canEdit,
        },
      },
    }));
  },

  getSettingsById: (stepId: string) => get().state[stepId],
}));
